import React from 'react';
import { clsx } from 'clsx';
import { File, FileImage, FileSpreadsheet, FileText, FileType } from 'lucide-react';
import { FILE_KIND_LABELS, fileKindOf, type FileKind } from '@/utils/fileKind';

const STYLE: Record<FileKind, { icon: React.ElementType; cls: string }> = {
  pdf: { icon: FileText, cls: 'bg-red-50 text-red-600' },
  image: { icon: FileImage, cls: 'bg-sky-50 text-sky-600' },
  word: { icon: FileType, cls: 'bg-blue-50 text-blue-600' },
  sheet: { icon: FileSpreadsheet, cls: 'bg-emerald-50 text-emerald-600' },
  text: { icon: FileText, cls: 'bg-slate-100 text-slate-600' },
  other: { icon: File, cls: 'bg-slate-100 text-slate-500' },
};

/** Ícone colorido por tipo de arquivo (PDF, imagem, Word, planilha, texto). */
export const FileTypeIcon: React.FC<{ fileName: string; contentType?: string; size?: number; className?: string }> = ({
  fileName,
  contentType,
  size = 18,
  className,
}) => {
  const kind = fileKindOf(fileName, contentType);
  const { icon: Icon, cls } = STYLE[kind];
  return (
    <span className={clsx('inline-flex items-center justify-center rounded-lg p-2 flex-shrink-0', cls, className)} title={FILE_KIND_LABELS[kind]}>
      <Icon size={size} />
    </span>
  );
};
